<ng-container *ngIf="hasLayouts">
  <iv-live-charts-dashboard-control-panel></iv-live-charts-dashboard-control-panel>
  <iv-live-charts-layout></iv-live-charts-layout>
</ng-container>
